<template>
  <div class="disease-detail xi" v-if="diseaseDetail.category" :class="diseaseDetail.category.substring(0, 2) == '中医' ? 'zhong' : 'xi'">
    <div class="topfixed">
      <hd-com></hd-com>
      <div class="banner">
        <div class="banner-text">
          <h3>
            {{ diseaseDetail.diseaseName }}<span v-if="diseaseDetail.diseaseAlias">（别名：{{ diseaseDetail.diseaseAlias }}）</span>
          </h3>
          <p>
            部门：<i>{{ diseaseDetail.category }}</i>
          </p>
          <div class="banner-right">
            <span v-if="!exist" @click="onCollection(diseaseDetail)">加入收藏</span>
            <span v-else @click="deleteAll()">取消收藏</span>
            <span @click="goback()" v-if="canBack">返回</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrap">
      <div class="content clearfix">
        <div class="breadcrumb">
          <p>
            当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><router-link to="/disease/diseaseBank">疾病库 </router-link><i class="el-icon-arrow-right"></i><a>{{ diseaseDetail.diseaseName }}</a>
          </p>
        </div>
        <div class="detail-box" v-if="diseaseDetail.relation">
          <div class="detail-top clearfix" v-if="Object.keys(diseaseDetail.relation).length > 0">
            <div class="left beforename" style="margin-left: 0; margin-right: 15px">
              <p>{{ diseaseDetail.diseaseName }}</p>
            </div>
            <div class="left dyimg">
              <img height="30px" :src="diseaseDetail.category.substring(0, 2) == '中医' ? require('../../assets/img/duizhao2.png') : require('../../assets/img/duizhao.png')" alt="" />
              <!--                            <p>中西医对应疾病</p>-->
            </div>
            <div class="left dyname" v-for="(item, index) in diseaseDetail.relation.slice(0, 3)" :key="index" @click="toDiseaseDetail('/disease/DiseaseDetail', item.hashKey)">
              <p><i>#</i>{{ item.diseaseName }}</p>
            </div>
            <div class="more" @click="dialogVisible = true">查看更多</div>
          </div>
          <div class="zztabfel" data-size="16" v-for="(menu, index) in menus" :key="index">
            <div class="sd-div" v-if="diseaseDetail.infoes.some((info) => info.title == menu)">
              <h3 class="sd-tit" data-size="24">
                {{ menu }}
                <el-button
                  size="mini"
                  round
                  v-if="menu == '诊断与鉴别诊断'"
                  @click="
                    CopyLink(
                      diseaseDetail.infoes
                        .filter((i) => i.title == menu)
                        .map((ele) => {
                          return ele.info;
                        })
                        .toString()
                        .replace(/\n/g, '</p> <p>'),
                    )
                  "
                >
                  复制</el-button
                >
              </h3>
              <div class="sd-mes" data-size="16">
                <p
                  v-html="
                    math(
                      diseaseDetail.infoes
                        .filter((i) => i.title == menu)
                        .map((ele) => {
                          return ele.info;
                        })
                        .toString()
                        .replace(/\n/g, '</p> <p>'),
                    )
                  "
                ></p>
              </div>
              <div
                class="readAllBtn"
                v-if="
                  diseaseDetail.infoes
                    .filter((i) => i.title == menu)
                    .map((ele) => {
                      return ele.info;
                    })
                    .toString().length >= 200
                "
                @click="readAll($event)"
              >
                <span class="btn-text" data-size="16">查看全部 <i class="el-icon-arrow-down"></i></span>
              </div>
              <!-- 临床表现  图片 -->
              <!-- <div class="demo-image__preview" v-if="menu == '临床表现' && diseaseDetail.infoes.some(info => info.title == '疾病图片' && info.info != null) ">
                                <div class="sd-mes-img" v-for="(item,index) in diseaseDetail.infoes.filter(i=> i.title == '疾病图片')" :key="index">
                                    <el-image :src="item.info"
                                              :preview-src-list="item.infos">
                                    </el-image>
                                </div>
                            </div> -->
            </div>
            <!-- <div class="sd-div" v-else-if="menu == '临床表现' && diseaseDetail.infoes.some(info => info.title == '疾病图片' && info.info != null) ">
                            <h3 class="sd-tit overview">{{menu}}</h3>
                            <div class="sd-mes">
                                <p></p>
                            </div>
                            <div class="demo-image__preview" v-if="menu == '临床表现' && diseaseDetail.infoes.some(info => info.title == '疾病图片' && info.info != null) ">
                                <div v-for="(item,index) in diseaseDetail.infoes.filter(i=> i.title == '疾病图片')" :key="index">
                                    <el-image style="width: 100px; height: 100px"
                                              :src="item.info"
                                              :preview-src-list="item.infos">
                                    </el-image>
                                </div>
                            </div>
                        </div> -->
            <div class="sd-div" v-else-if="menu == '辨证论治' && diseaseDetail.discriminates != 0">
              <h3 class="sd-tit" data-size="24">{{ menu }}</h3>
              <el-collapse :value="opened">
                <el-collapse-item v-for="(cate, index) in diseaseDetail.discriminates" :key="index" :title="cate.category2 == null || cate.category2 == '' ? cate.category1 : cate.category3 == null || cate.category3 == '' ? cate.category1 + '-' + cate.category2 : cate.category1 + '-' + cate.category2 + '-' + cate.category3" :name="cate.content">
                  <div class="divider-content" data-size="16">
                    <p v-html="math(cate.content.replace(/\n/g, '</p> <p>'))"></p>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
        <el-scrollbar class="left-nav-wrap">
          <!-- 具体要包裹的内容 -->
          <div class="fast-nav">
            <ul class="timeline is-reverse">
              <div v-for="(menu, index) in menus" :key="index" @click="jump(index)" :class="index == 0 ? 'active' : ''">
                <li class="timeline-item" v-if="diseaseDetail.infoes.some((info) => info.title == menu)">
                  <div class="timeline-item__tail" v-if="menu != diseaseDetail.infoes[diseaseDetail.infoes.length - 1].title"></div>
                  <div class="timeline-item__node"></div>
                  <div class="timeline-item__text" data-size="17">
                    <h3>{{ menu }}</h3>
                  </div>
                </li>
                <li class="timeline-item" v-else-if="menu == '辨证论治' && diseaseDetail.discriminates != 0">
                  <div class="timeline-item__tail"></div>
                  <div class="timeline-item__node"></div>
                  <div class="timeline-item__text" data-size="17">
                    <h3>{{ menu }}</h3>
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <el-dialog title="中西医对应疾病" :visible.sync="dialogVisible" width="35%">
      <ul class="detail-top" style="max-height: 500px; min-height: 100px; overflow: auto; background: #ffffff; padding: 0">
        <li v-for="(item, index) in diseaseDetail.diseaseRelation" :key="index">
          <div class="clearfix">
            <h4 class="">{{ item.keys }}：</h4>
            <div class="left dyname" style="margin: 5px 20px 5px 0px" v-for="(relation, Rindex) in item.value" :key="Rindex" @click="toDiseaseDetail('/disease/DiseaseDetail', relation.hashKey)">
              <p><i>#</i>{{ relation.diseaseName }}</p>
            </div>
          </div>
        </li>
      </ul>
    </el-dialog>
    <ft-com></ft-com>
    <!-- <rt-bar></rt-bar> -->
    <staticTime></staticTime>
    <!-- <el-tooltip
      ref="tooltip"
      :content="tooltipContent"
      placement="top-start"
      effect="dark"
      :manual="true"
      v-model="tooltipVisible"
    >
    </el-tooltip> -->
    <el-dialog
      title="释义"
      :visible.sync="dialogVisibleCi"
      width="30%"
      >
      <toDictionary :dictIds = "dictId"></toDictionary>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleCi = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleCi = false">确 定</el-button>
      </span>
    </el-dialog>
        <!-- <el-dialog
      title="释义"
      :visible.sync="dialogVisibleDetail"
      width="30%"
      >
      <p v-for="(item,index) in infoDetailData" :key="index"> {{ item.name }} -------------<span v-if="item.type == 'Disease'">疾病</span><span v-if="item.type == 'Dict'">词典</span></p>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDetail = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleDetail = false">确 定</el-button>
      </span>
    </el-dialog> -->
    <!-- <p v-html="replaceContentDetail(infoDetail.toString().replace(/\n/g, '</p> <p>'))" @click="handleMultiLinkClick"></p> -->
  </div>
</template>

<script>
import hdCom from "../../components/header"; //引入组件
import ftCom from "../../components/footer"; //引入组件

import toDictionary from "../../components/toDictionary"; //引入组件
// import rtBar from "../../components/right";
import staticTime from "../../components/staticTime";
import { Disease } from "../../components/Disease/Disease";
import { DiseaseUtility, replaceContent, checkNameAndPath, toSearchList, toDetailInfo,toDetailInfoOpenTab } from "../../utils/diseaseUtility";
import {toDisease} from "../../utils/relation";
import { Collection } from "../../components/collection/Collection";
import { GroupBy } from "../../utils/extend";
import $ from "jquery";
export default {
  name: "DiseaseDetail",
  components: {
    hdCom,
    ftCom,
    // rtBar,
    staticTime,
    toDictionary
  },
  data() {
    var disease = new Disease(this.TokenClient, this.Services.Disease);
    var diseaseUtility = new DiseaseUtility(this.TokenClient, this.Services);
    var collection = new Collection(this.TokenClient, this.Services.Statics);
    return {
      activeName: ["index"],
      ifOver: true, // 文本是否超出三行，默认否
      unfold: false, // 文本是否是展开状态 默认为收起
      hashKey: this.$route.query.hashKey, //列表页id
      diseaseDetail: {}, //初始化详情
      menus: {}, //疾病菜单
      diseaseDomain: disease,
      diseaseUtilityDomain: diseaseUtility,
      scroll: "",
      collectionDomain: collection,
      entityData: {},
      dialogVisible: false,
      showall: false, //刚开始没有激活
      bussinessHeight: "",
      exist: false,
      collectionId: "",
      scrollTop: 0,
      canBack:true,
      tooltipContent: '', // 控制显示隐藏
      tooltipVisible: false,
      dialogVisibleCi:false,
      dictId:0,
      typeFood:this.$route.query.type,
      dialogVisibleDetail:false,
      infoDetailData:[],
      // infoDetail:'[[症状|Dict|58454,Dict|44563]]：[[头晕|Disease|30b687a6-1461-475c-8428-3853074f55c9,Dict|12453]][[耳鸣|Disease|c1802f6a-552a-4525-bb29-6551f764f0a9,Disease|3e51f5bb-e0dd-4cbc-ac22-8f7f64c3186e,Dict|14351,Dict|22042]]，[[目涩|Dict|9116]]，[[咽干|Dict|40297,Dict|50923]]，[[五心烦热|Dict|4316]]，[[盗汗|Disease|0dda94f0-5602-40ef-b338-6f622da663ee,Disease|19ec4ae1-02bd-4ac2-9503-e910494382e1,Dict|56284,Dict|19165]]，[[不寐|Disease|0f39fe87-417c-4268-bb1f-8becc4a74f12,Disease|9c0718eb-8cda-4277-b6a3-52d82104d211,Dict|4469]][[多梦|Dict|19789]]，[[腰膝酸软|Dict|63689]]，[[大便|Dict|1517]]干涩，[[小便|Dict|2643]]热赤，[[舌红|Dict|16680]]少苔，脉细数或细弦。\n    [[治法|Dict|48804]]：[[滋补肝肾|Dict|61835]]，平潜[[肝阳|Dict|30193]]。\n    方药：[[杞菊地黄丸|Herbal|f3888b96-da5a-4eb7-8fa6-0b8d47c70d19,SelfDiagnosis|72d35271-3f44-407a-9bd3-c24a620bc76f,Drug|4b70d417-bb27-4af3-bcf6-88b02d969c57,Dict|26159]]加减。[[心肾不交|Dict|7185]]者，加[[阿胶|Material|4180737e-9b2c-4b9d-8172-055178d19763,Drug|d6d3aeae-87b0-412c-a98b-c605b4d0d976,Dict|42181]]、[[鸡子黄|Material|751765d2-6763-4e96-88c0-793c57192396,Dict|43139]]、[[酸枣仁|Material|d0d2d028-57d1-47e2-99cc-1ccec409fa4f,Dict|65224]]、[[柏子仁|Material|8bf36f24-54e8-49a3-a228-a00bb36c9f80,Dict|50103]]等[[交通心肾|Dict|20175]]，[[养心安神|Dict|53341]]。'
    };
  },
  watch: {
    "$route.query.hashKey"() {
      /*监听产品id 及时变更data数据*/
      this.hashKey = this.$route.query.hashKey;
      if (this.hashKey) {
        this.getDiseaseDetail();
        // 切换后恢复新页面的滚动位置
        // this.$nextTick(() => {
        //   this.restoreScrollPosition();
        // });
      }
    },
  },
  computed: {
    opened() {
      return this.diseaseDetail.discriminates.map((i) => {
        return i.content;
        console.log(i);
      });
    },
  },
  mounted() {
    this.$bus.$emit("select", "disease");
    this.getDiseaseDetail();
  },
  created() {
    let _this = this;
    this.canBack = window.history.length > 1;
    window.getPageInfo = _this.getPageInfo;
  },
  activated() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.dataScroll);
  },
  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.dataScroll);
  },
  methods: {
  //   handleMultiLinkClick(e){
  //   if(e.target.classList.contains('link-multi')){
  //     const jsonStr = e.target.dataset.list.replace(/&quot;/g, '"');
  //     const dataList = JSON.parse(jsonStr);
  //     console.log('全部条目', dataList);
  //     this.infoDetailData = dataList
  //     this.dialogVisibleDetail = true
  //   }
  // },
// replaceContentDetail(content) {
//   return content.replace(/\[\[([\s\S]+?)\]\]/g, (match, innerStr) => {
//     const items = innerStr.split(',').map(i => i.trim()).filter(Boolean);
//     if(!items.length) return '';

//     const firstArr = items[0].split('|');
//     const showName = firstArr[0];
//     const dataList = items.map(str => {
//       const arr = str.split('|');
//       return {
//         name: arr.length >=3 ? arr[0] : showName,
//         type: arr[arr.length >=3 ? 1 : 0],
//         hashKey: arr[arr.length >=3 ? 2 : 1]
//       }
//     })
//     const jsonStr = JSON.stringify(dataList).replace(/"/g, '&quot;');

//     return `<a style='color: #b76c12;margin-right:4px' href="javascript:;" class="link-multi" data-list="${jsonStr}">${showName}</a>`;
//   })
// },
    // showTooltip(title, p1, p2,event) {
    //   this.tooltipVisible = false;
    //   this.tooltipContent = title;
      
    //     // 创建一个临时 span 插到点击的元素前面
    //     const tempSpan = document.createElement('span');
    //     tempSpan.style.display = 'inline-block';
    //     tempSpan.style.width = '1px';
    //     tempSpan.style.height = '1px';
    //     event.target.parentNode.insertBefore(tempSpan, event.target);

    //       this.$nextTick(() => {
    //           const tooltip = this.$refs.tooltip;
    //           tooltip.referenceElm = tempSpan;
    //           tooltip.updatePopper();
    //           this.tooltipVisible = true;
    //           setTimeout(() => {
    //             this.tooltipVisible = false;
    //             tempSpan.remove(); // 用完删除
    //           }, 2500);
    //         });
    // },
    handleScroll() {
      let scrollY = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // 原有逻辑：处理固定定位
      let scrollObj = document.querySelector(".left-nav-wrap");
      let topfixed = document.querySelector(".topfixed");

      if (scrollY > 80) {
        topfixed.style.position = "fixed";
        topfixed.style.top = 0;
        topfixed.style.zIndex = 99;
        scrollObj.style.position = "fixed";
        scrollObj.style.top = "100px";
      } else {
        topfixed.style.position = "initial";
        topfixed.style.top = "none";
        scrollObj.style.position = "absolute";
        scrollObj.style.top = "auto";
      }

      this.highlightCurrentNav(scrollY);
    },
    highlightCurrentNav(scrollY) {
      const sections = document.getElementsByClassName("zztabfel");
      const navItems = document.querySelectorAll(".timeline>div");

      for (let i = sections.length - 1; i >= 0; i--) {
        if (scrollY >= sections[i].offsetTop - 250) {
          navItems.forEach((item, idx) => {
            if (idx === i) {
              item.classList.add("active");
            } else {
              item.classList.remove("active");
            }
          });
          break;
        }
      }
    },
    dataScroll: function () {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    },
    // 修改返回方法
    goback() {
      this.$router.go(-1);
    },
    toDiseaseDetail(path, hashKey) {
      toDisease(hashKey)
    },
    readAll(e) {
      const target = e.currentTarget;
      // 寻找父元素的兄弟元素进行显示与隐藏控制
      $(target).prev().addClass("all");
      $(target).hide();
    },
    //详情获取
    getDiseaseDetail: function () {
      ///api/Diseases/{diseaseId}/{searchId}/{keyWord}
      this.diseaseDetail = []
      const loading = this.$loading({
        lock: true,
        text: "当前内容过多请耐心等待！",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.01)",
      });
      var _this = this;
      let params = ''
      if (_this.typeFood == 'food') {
        params = `${_this.hashKey}/true/1`;
      } else {
        params = `${this.hashKey}`;
      }
      _this.diseaseDomain.Detail(
        params,
        function (data) {
          loading.close();
          _this.diseaseDetail = data.data.disease;
          _this.menus = data.data.menus;
          var list = data.data.disease.relation;
          var results = GroupBy(list, function (item) {
            return [item.category];
          });
          var dic = [];
          results.forEach(function (item) {
            var interaction = {
              keys: item[0].category,
              value: item,
            };
            dic.push(interaction);
          });
          data.data.disease.diseaseRelation = dic;
          _this.entityData = {
            type: "disease",
            name: _this.diseaseDetail.diseaseName,
            hashKey: _this.diseaseDetail.hashKey,
            id: _this.diseaseDetail.diseaseId,
            entityType: _this.diseaseDetail.category,
          };
          _this.checkExist();
        },
        function (error) {
          loading.close();
          console.log("疾病详情请求异常:", error);
        },
      );
    },
    checkExist() {
      var _this = this;
      _this.collectionDomain.Exist(
        this.entityData.type,
        this.entityData.hashKey,
        this.entityData.id,
        function (data) {
          _this.exist = data.data.exist;
          _this.collectionId = data.data.collectionId;
        },
        function (err) {},
      );
    },
    //详情关联词
    math(info) {
      return replaceContent(info);
    },
    //跳转疾病详情
    getPageInfo(name, type, hashKey) {
      if (hashKey == "Search") {
        toSearchList(checkNameAndPath(type).typeName, name);
      } else {
        if (type == "Disease") {
          this.hashKey = hashKey;
          this.getDiseaseDetail();
        }
        else if (type == "Dict") {
          this.dialogVisibleCi = true
          this.dictId = hashKey
          console.log(this.dictId)
          //  this.showTooltip(name, type, hashKey,event);
        }
        else {
          toDetailInfoOpenTab(checkNameAndPath(type).path, hashKey, type);
        }

       
      }
    },
    //相关疾病分组
    dietGroup: function (list) {
      const results = GroupBy(list, function (item) {
        return [item.target];
      });
      var dic = [];
      results.forEach(function (item) {
        var interaction = {
          keys: item[0].target,
          value: item,
        };
        dic.push(interaction);
      });
      return dic;
    },
    deleteAll: function () {
      var _this = this;
      var idarr = [_this.collectionId];
      _this.collectionDomain.Delete(
        idarr,
        function (data) {
          _this.checkExist();
          _this.$message({
            center: true,
            type: "success",
            message: "取消成功!",
          });
        },
        function (error) {
          console.log(error);
        },
      );
    },
    //收藏
    onCollection: function (item) {
      var _this = this;
      var entityType = 0;
      if (item.category.indexOf("西医") != -1) {
        entityType = 1;
      }
      if (item.category.indexOf("中医") != -1) {
        entityType = 2;
      }
      _this.collectionDomain.Put(
        "disease",
        item.diseaseName,
        item.hashKey,
        item.diseaseId,
        entityType,
        function (data) {
          _this.checkExist();
          _this.$message({
            type: "success",
            message: "收藏成功!",
          });
        },
        function (err) {
          if (err.status === 400) {
            _this.$message.error("请勿重复收藏!");
          }
        },
      );
    },

    CopyLink(data) {
      // var editItem = this.tableData[index];
      var copyData = data.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "");
      this.copy(copyData);
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
    jump(index) {
      let jump = document.getElementsByClassName("zztabfel");
      // 获取需要滚动的距离
      let total = jump[index].offsetTop - 200;
      window.scroll(0, total);
      var $navs = $(".timeline div");
      $navs.eq(index).addClass("active").siblings().removeClass("active");
    },
  },
  props: {
    content: {
      type: String,
      default: "本病主要由脏腑虚损，咽喉失养，以及痰凝血瘀，结聚咽喉所致。体质病理基础为虚弱质，可兼夹失调体质偏热型、偏寒型及偏瘀型。\n" + "\n" + "<br>（1）肺肾阴虚，虚火灼咽；温热病后，或劳伤过度，耗伤阴液，肺肾阴虚，咽失濡养；或虚火上炎，熏蒸咽窍，发为喉痹。 \n" + "<br>（2）脾胃虚弱，咽失濡养：思虑过度，劳伤脾胃，或饮食不节，或久病伤脾，致脾胃虚弱，水谷精微生化不足，咽喉失于濡养，发为喉痹。 \n" + "<br>（3）痰凝血瘀，结聚咽窍：饮食不节，脾胃受损，运化失常，水湿内停，聚而为痰，凝结咽窍；或喉痹反复发作，余邪滞留咽窍，久则经脉瘀滞，闭阻咽窍而为病。 ",
    },
  },
};
//过滤html标签
function filter(html) {
  return html
    .replace(/<(?:.|\n)*?>/gm, "")
    .replace(/(&rdquo;)/g, '"')
    .replace(/&ldquo;/g, '"')
    .replace(/&mdash;/g, "-")
    .replace(/&nbsp;/g, "")
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<")
    .replace(/<[\w\s"':=\/]*/, "")
    .replace(/\<table/g, '<div class="table-box"><table')
    .replace(/\/table>/g, "/table></div>");
}
</script>

<style scoped>
@import "../../assets/css/header.css";
@import "../../assets/css/footer.css";

/*收缩框*/
.showall {
  padding: 10px;
  height: 300px;
  overflow: hidden;
  clear: both;
  background: #f5f5f5;
  margin-top: 6px;
}

.showall.active {
  height: auto;
  background: #fff;
  min-height: 150px;
}

.readAllBtn {
  position: relative;
  height: 78px;
  margin-top: -68px;
  background-image: linear-gradient(rgba(255, 255, 255, 0.8), #ffffff);
  text-align: center;
}

.xi .readAllBtn .btn-text {
  position: absolute;
  bottom: 0;
  color: #1fb7a6;
  cursor: pointer;
}

.zhong .readAllBtn .btn-text {
  position: absolute;
  bottom: 0;
  color: #b76c12;
  cursor: pointer;
}

.xi .banner {
  width: 100%;
  height: 116px;
  background: url("../../assets/img/jbk_banner.png") center no-repeat;
}

.zhong .banner {
  width: 100%;
  height: 116px;
  background: #b76c12;
}

.banner-text {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}

.banner-text h3 {
  padding-top: 25px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text h3 span {
  font-size: 14px;
}

.banner-text p {
  font-size: 14px;
  color: #ffffff;
}

.banner-text p i {
  font-style: normal;
}

.banner-right {
  position: absolute;
  right: 5px;
  top: 45px;
}

.banner-right span {
  display: inline-block;
  margin-left: 20px;
  width: 132px;
  height: 32px;
  border: 1px solid #ffffff;
  border-radius: 32px;
  box-sizing: border-box;
  text-align: center;
  color: #ffffff;
  line-height: 30px;
  cursor: pointer;
}

.banner-right span:hover {
  background-color: #ffffff;
  color: #00ab98;
}

.zhong .banner-right span:hover {
  background-color: #ffffff;
  color: #b76c12;
}

.content-wrap {
  background: #f8f8f8;
}

.content-wrap .content {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px;
  background: none;
}

.breadcrumb p {
  padding: 20px 0;
  color: #999999;
  font-size: 16px;
}

.breadcrumb p a {
  color: #999999;
  font-size: 16px;
  margin: 0 5px;
}

.detail-box {
  float: left;
  padding: 30px 35px;
  width: 830px;
  background: #ffffff;
  box-shadow: 5px 0 8px rgba(224, 224, 224, 0.3);
}

.detail-top {
  padding: 15px 10px;
  background: #f8f8f8;
}

.detail-top .dyimg {
  text-align: center;
}

.detail-top .dyimg p {
  font-size: 12px;
  color: #333333;
}

.detail-top .beforename {
  margin-right: 20px;
  padding: 0 10px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background: #f0f0f0;
  font-size: 14px;
  color: #333333;
}

.detail-top .dyname {
  margin-left: 20px;
  padding: 0 10px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background: #f0f0f0;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.detail-top .dyname p i {
  margin-right: 10px;
  display: inline-block;
  color: #e62828;
  font-size: 12px;
  background-color: #ffffff;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  text-align: center;
  font-style: normal;
}

.detail-top .dyname p:hover {
  color: #1fb7a6;
  text-decoration: underline;
}

.sd-div {
  padding: 30px 0;
  border-top: 1px solid #e5e5e5;
}

.sd-div .sd-tit {
  position: relative;
  font-size: 24px;
  color: #333333;
  font-weight: normal;
  margin-bottom: 30px;
}

.sd-div .sd-tit.overview {
  font-size: 26px;
  color: #333333;
  padding-left: 15px;
  border-left: 3px solid #333;
  line-height: 26px;
}

.sd-div .sd-tit > .el-button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* .sd-div .sd-mes p {
    text-indent: 2em;
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 10px;
} */

.sd-div .sd-mes {
  /* max-height: 200px; */
  overflow: hidden;
  text-overflow: ellipsis;
}

.sd-div .sd-mes.all {
  max-height: initial;
}

.sd-mes-img {
  display: inline-block;
  margin: 15px;
}

.divider {
  position: relative;
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
  border-top: 1px dashed #999999;
}

.divider .divider-text {
  position: absolute;
  background-color: #fff;
  font-weight: 500;
  color: #333333;
  font-size: 20px;
  transform: translateY(-50%);
  line-height: 35px;
}

.divider .divider-text span {
  color: #00ad9a;
  font-size: 12px;
  line-height: 35px;
}

.divider-content {
  padding: 0 0 15px;
}

.divider-content p {
  /* font-size: 16px; */
  color: #333333;
}

.bybj-item {
  padding: 15px;
  border: 1px solid #f5f5f5;
  box-shadow: 5px 0 8px rgba(224, 224, 224, 0.3);
}

.bybj-tit {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
}

.bybj-txt {
  font-size: 16px;
  color: #666666;
  margin-top: 20px;
}

.bybj-txt p {
  color: #666666;
}

.over-hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.status-btn {
  color: #00ab98;
  cursor: pointer;
}

.left-nav-wrap {
  position: absolute;
  margin-left: 950px;
  /*max-height: 500px;*/
  max-height: calc(100vh - 260px - 205px);
  /* border: 1px solid #e5e5e5; */
  box-shadow: 5px 0 8px rgba(224, 224, 224, 0.3);
  background: #ffffff;
}

/deep/ .el-scrollbar .el-scrollbar__wrap {
  max-height: 500px;
  overflow-x: hidden;
}

.fast-nav {
  width: 250px;
  padding: 20px 0 20px 40px;
  box-sizing: border-box;
  z-index: 10;
}

.timeline-item {
  position: relative;
  padding-bottom: 17px;
  padding-top: 8px;
}

.timeline-item__tail {
  position: absolute;
  top: 15px;
  left: 3px;
  height: 100%;
  border-left: 1px solid #e5e5e5;
}

.timeline-item__node {
  position: absolute;
  background-color: #cccccc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 15px;
  left: -1px;
  width: 9px;
  height: 9px;
}

.timeline-item__text {
  position: relative;
  padding-left: 28px;
  top: -3px;
  cursor: pointer;
}

.timeline-item__text h3 {
  font-size: 17px;
  color: #333;
  font-weight: normal;
}

.timeline-item__text p {
  line-height: 2.5;
  color: #565656;
  font-weight: normal;
}

.xi .timeline div.active .timeline-item__node,
.xi .timeline div:hover .timeline-item__node {
  background-color: #1fb7a6;
}

.xi .timeline div.active .timeline-item__text h3,
.xi .timeline div:hover .timeline-item__text h3 {
  color: #1fb7a6;
}

.zhong .timeline div.active .timeline-item__node,
.zhong .timeline div:hover .timeline-item__node {
  background-color: #b76c12;
}

.zhong .timeline div.active .timeline-item__text h3,
.zhong .timeline div:hover .timeline-item__text h3 {
  color: #b76c12;
}

.xi .more {
  float: right;
  color: #1fb7a6;
  border: 1px solid #1fb7a6;
  border-radius: 13px;
  padding: 0 10px;
}

.xi .more:hover {
  cursor: pointer;
  color: #ffffff;
  border: 1px solid #1fb7a6;
  background: #1fb7a6;
}

.zhong .more {
  float: right;
  color: #b76c12;
  border: 1px solid #b76c12;
  border-radius: 13px;
  padding: 0 10px;
}

.zhong .more:hover {
  cursor: pointer;
  color: #ffffff;
  border: 1px solid #b76c12;
  background: #b76c12;
}
</style>
<style>
.disease-detail .bar-list .yysc {
  display: none !important;
}

.disease-detail .el-image__inner {
  height: 160px;
  width: auto;
}

.disease-detail .el-collapse-item__header {
  background-color: #1fb7a6;
  color: #ffffff;
  font-size: 18px;
  padding: 0 20px;
}

.disease-detail.zhong .el-collapse-item__header {
  background-color: #b76c12;
  color: #ffffff;
  font-size: 18px;
  padding: 0 20px;
}

.disease-detail .el-collapse-item__wrap {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.disease-detail .el-collapse-item__content {
  padding: 15px 5px;
}

.sd-div .sd-mes p a {
  color: #1fb7a6 !important;
}

.zhong .sd-div .sd-mes p a {
  color: #b76c12 !important;
}

.zhong .el-collapse-item a {
  color: #b76c12 !important;
}

.el-scrollbar__wrap {
  overflow: auto;
}
</style>
